import React, { useState, useEffect, useRef } from 'react';
import { Select, Form, Space } from 'antd';
import MinusCircleFilled from '@ant-design/icons/MinusCircleFilled';
import PlusCircleFilled from '@ant-design/icons/PlusCircleFilled';
import classnames from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import { debounce, isObject } from 'lodash';
import { apiHolder, apis } from 'api';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import TagCloseIcon from '@web-common/components/UI/Icons/svgs/TagCloseSvg';
import ContactScheduleModal from '@web-common/components/UI/SiriusContact/scheduleModal';
import TriangleDownIcon from '@web-common/components/UI/Icons/svgs/TriangleDown';
import styles from './conditionAction.module.scss';
import variables from '@web-common/styles/export.module.scss';
import { getIn18Text } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
import { MAIL_CLASSIFY_BODY_FIELD, getDefaultOperatorByField, normalizeConditionOperatorByField } from './operator_utils';
const { Option } = Select;
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const defaultCondition = {
    field: 'from',
    ignoreCase: false,
    operator: 'contains',
    operand: [],
};
const filterRules = (rules, isEntrance) => rules.map(item => {
    const normalizedOperator = normalizeConditionOperatorByField(item.field, item.operator);
    if (item.field === 'subject' && isEntrance) {
        return Object.assign(Object.assign({}, item), { operator: normalizedOperator, operand: [] });
    }
    return Object.assign(Object.assign({}, item), { operator: normalizedOperator });
});
const convert2ContactItem = (operand = []) => {
    if (operand === null || operand === void 0 ? void 0 : operand.length) {
        return operand.map((item) => (typeof item === 'string' ? { email: item, name: item } : item));
    }
    return operand;
};
const NON_MAIL_OPTION = ['subject', 'body', 'attachmentName', 'accounts'];
export const ConditionAction = props => {
    var _a;
    const { operator = 'and', rules = [], form, isEntrance, _account, hideHeader } = props;
    const { recent100 } = useAppSelector(state => state.mailClassifyReducer);
    const [conditionRules, setConditionRules] = useState(rules.length > 0 ? filterRules(rules, isEntrance) : [defaultCondition]);
    const [condFields, setCondFields] = useState([]);
    const [adding, setAdding] = useState(false);
    const [connectText, setConnectText] = useState(operator === 'and' ? getIn18Text('QIE') : getIn18Text('HUO'));
    const [searchValue, setSearchValue] = useState(isEntrance ? ((_a = rules.find(item => item.field === 'subject')) === null || _a === void 0 ? void 0 : _a.operand[0]) || '' : '');
    const [subjectEditState, setSubjectEditState] = useState(!!(isEntrance && rules.some(item => item.field === 'subject')));
    const [currentIndex, setCurrentIndex] = useState(subjectEditState
        ? Math.max(rules.findIndex(item => item.field === 'subject'), 0)
        : 0);
    const searchValueSynced = useRef(false);
    useEffect(() => {
        var _a;
        if (isEntrance && !searchValueSynced.current) {
            const subjectRule = rules.find(item => item.field === 'subject');
            const operandVal = ((_a = subjectRule === null || subjectRule === void 0 ? void 0 : subjectRule.operand) === null || _a === void 0 ? void 0 : _a[0]) || '';
            if (operandVal) {
                setSearchValue(operandVal);
                setSubjectEditState(true);
                searchValueSynced.current = true;
            }
        }
    }, [rules, isEntrance]);
    const handleSearch = (str) => {
        setSearchValue(str);
    };
    const handleNonMailSearch = (str, index) => {
        var _a, _b, _c, _d;
        const currentValues = ((_b = (_a = form.getFieldValue('condictions')) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.operand) || [];
        const existingLength = currentValues.reduce((sum, item) => { var _a; return sum + (((_a = item === null || item === void 0 ? void 0 : item.trim()) === null || _a === void 0 ? void 0 : _a.length) || 0); }, 0);
        if (existingLength + str.trim().length > 1000) {
            const remainingLength = 1000 - existingLength;
            if (remainingLength > 0) {
                const truncatedStr = str.slice(0, remainingLength);
                if (index === currentIndex || (subjectEditState && ((_c = rules[index]) === null || _c === void 0 ? void 0 : _c.field) === 'subject')) {
                    setSearchValue(truncatedStr);
                }
                SiriusMessage.warn({ content: getIn18Text('内容不得超过1000个字符') });
            }
            else {
                SiriusMessage.warn({ content: getIn18Text('内容不得超过1000个字符') });
            }
            return;
        }
        if (index === currentIndex || (subjectEditState && ((_d = rules[index]) === null || _d === void 0 ? void 0 : _d.field) === 'subject')) {
            setSearchValue(str);
        }
    };
    const updateFields = (rules) => {
        form.setFieldsValue({ condictions: rules });
    };
    useEffect(() => {
        if (rules.length <= 0) {
            return;
        }
        Promise.all(rules.map(async (item) => {
            if (!NON_MAIL_OPTION.includes(item === null || item === void 0 ? void 0 : item.field)) {
                const uniqueOperand = Array.isArray(item.operand) ? Array.from(new Set(item.operand)) : item.operand;
                const internalContact = (await contactApi.doGetContactByItem({
                    type: 'EMAIL',
                    value: uniqueOperand,
                    filterType: 'enterprise',
                    _account,
                })).map(itm => {
                    var _a, _b;
                    return ({
                        name: (_a = itm === null || itm === void 0 ? void 0 : itm.contact) === null || _a === void 0 ? void 0 : _a.contactName,
                        email: (_b = itm === null || itm === void 0 ? void 0 : itm.contact) === null || _b === void 0 ? void 0 : _b.accountName,
                    });
                });
                const externalContact = item.operand.filter(itm => !internalContact.map(itm => itm.email).includes(itm));
                item.operand = [...internalContact, ...externalContact.map(itm => ({ name: itm, email: itm }))];
            }
            return item;
        })).then(res => {
            const updateRules = filterRules(res, isEntrance);
            updateFields(updateRules);
            setConditionRules(updateRules);
            setCurrentIndex(-1);
        });
    }, [rules.length]);
    useEffect(() => {
        form.setFieldsValue({ operator });
    }, [operator]);
    useEffect(() => {
        setConnectText(operator === 'and' ? getIn18Text('QIE') : getIn18Text('HUO'));
    }, [operator]);
    useEffect(() => () => {
        form.setFieldsValue({
            operator: 'and',
            condictions: [defaultCondition],
        });
    }, []);
    const isNonMailOption = (index) => { var _a; return NON_MAIL_OPTION.includes(((_a = form.getFieldValue('condictions')[index]) === null || _a === void 0 ? void 0 : _a.field) || ''); };
    const validatorRule = (index) => (_, value) => {
        var _a;
        const trimValueList = value === null || value === void 0 ? void 0 : value.filter((item) => { var _a; return (isObject(item) ? (_a = item === null || item === void 0 ? void 0 : item.email) === null || _a === void 0 ? void 0 : _a.trim() : item === null || item === void 0 ? void 0 : item.trim()); });
        const character1 = (trimValueList === null || trimValueList === void 0 ? void 0 : trimValueList.find((item) => { var _a; return (isObject(item) ? ((_a = item === null || item === void 0 ? void 0 : item.email) === null || _a === void 0 ? void 0 : _a.indexOf('\\')) > -1 : (item === null || item === void 0 ? void 0 : item.indexOf('\\')) > -1); })) ? '\\' : '';
        const character2 = (trimValueList === null || trimValueList === void 0 ? void 0 : trimValueList.find((item) => { var _a; return (isObject(item) ? ((_a = item === null || item === void 0 ? void 0 : item.email) === null || _a === void 0 ? void 0 : _a.indexOf('"')) > -1 : (item === null || item === void 0 ? void 0 : item.indexOf('"')) > -1); })) ? '"' : '';
        if (character1 && character2) {
            return Promise.reject(new Error(`不支持保存特殊字符${character1}和${character2}，请修改`));
        }
        if (character1 || character2) {
            return Promise.reject(new Error(`不支持保存特殊字符${character1 || character2}，请修改`));
        }
        const fieldType = (_a = form.getFieldValue('condictions')[index]) === null || _a === void 0 ? void 0 : _a.field;
        const max = isObject(value[0]) ? 30 : fieldType === 'subject' ? 10 : 3;
        if ((trimValueList === null || trimValueList === void 0 ? void 0 : trimValueList.length) > max) {
            return Promise.reject(new Error(getIn18Text(`NEIRONGBUDECHAO${max}`)));
        }
        return Promise.resolve();
    };
    const validatorTextLength = (_, value) => {
        if (!value || value.length === 0) {
            return Promise.resolve();
        }
        const totalLength = value.reduce((sum, item) => { var _a; return sum + (((_a = item === null || item === void 0 ? void 0 : item.trim()) === null || _a === void 0 ? void 0 : _a.length) || 0); }, 0);
        if (totalLength > 1000) {
            return Promise.reject(new Error(getIn18Text('内容不得超过1000个字符，请修改')));
        }
        return Promise.resolve();
    };
    const warnMessage = () => {
        SiriusMessage.warn({ content: getIn18Text('YIYOUZHONGFUNEI') });
    };
    const getNonMailFieldText = (fieldValue) => {
        if (fieldValue === 'subject') {
            return getIn18Text('ZHUTI');
        }
        if (fieldValue === MAIL_CLASSIFY_BODY_FIELD) {
            return getIn18Text('YOUJIANZHENGWEN');
        }
        return getIn18Text('FUJIANMINGCHENG');
    };
    const handleSelectChange = (value, index) => {
        const specialType = NON_MAIL_OPTION.includes(value);
        const rules = cloneDeep(form.getFieldValue('condictions'));
        if (searchValue) {
            const subjectIndex = rules.findLastIndex((item) => item.field === 'subject');
            if (subjectIndex > -1) {
                rules.splice(subjectIndex, 1, Object.assign(Object.assign({}, defaultCondition), { operand: [searchValue], field: 'subject' }));
                handleSearch('');
            }
        }
        const oriFields = condFields;
        oriFields[index] = Object.assign(Object.assign({}, condFields[index]), { type: value });
        setCondFields(condFields);
        rules.splice(index, 1, Object.assign(Object.assign({}, defaultCondition), { operator: getDefaultOperatorByField(value), operand: specialType ? [] : rules[index].operand, field: value }));
        updateFields(rules);
        setSubjectEditState(false);
    };
    const filterValueForm = (valList, type) => {
        var _a;
        if (type === 'mail') {
            return valList.filter((item) => item.email.trim());
        }
        const trimList = (_a = valList === null || valList === void 0 ? void 0 : valList.map((item) => item === null || item === void 0 ? void 0 : item.trim())) === null || _a === void 0 ? void 0 : _a.filter((item) => item);
        const noRepeatList = Array.from(new Set(trimList));
        if (trimList.length !== noRepeatList.length) {
            warnMessage();
        }
        return noRepeatList.filter(item => item);
    };
    const handleSelect = debounce((value, option) => {
        if (value === option.value) {
            warnMessage();
        }
    }, 300);
    const handleAdd = (fields, add, index) => {
        if (fields.length >= 10 || adding) {
            return;
        }
        setAdding(true);
        const newIndex = index + 1;
        add(defaultCondition, newIndex);
        updateFields(form.getFieldValue('condictions'));
        setSubjectEditState(false);
        setCurrentIndex(newIndex);
        const timer = setTimeout(() => {
            setAdding(false);
            clearTimeout(timer);
        }, 300);
    };
    const handleDelete = (fields, remove, index) => {
        if (fields.length > 1) {
            remove(index);
            updateFields(form.getFieldValue('condictions'));
            setConditionRules(form.getFieldValue('condictions'));
        }
    };
    return (React.createElement("div", { className: styles.classifyCondition },
        !hideHeader && (React.createElement("div", { className: styles.classifyConditionHead },
            React.createElement("span", { className: styles.classifyConditionTitle }, getIn18Text('SHOUDAOXINYOUJIAN')),
            React.createElement(Form.Item, { name: "operator", initialValue: operator },
                React.createElement(Select, { getPopupContainer: node => node.parentElement, style: { width: 128 }, suffixIcon: React.createElement(TriangleDownIcon, null), onChange: val => setConnectText(val === 'and' ? getIn18Text('QIE') : getIn18Text('HUO')) },
                    React.createElement(Option, { value: "and" }, getIn18Text('SUOYOUTIAOJIAN')),
                    React.createElement(Option, { value: "or" }, getIn18Text('RENYITIAOJIAN')))))),
        React.createElement("div", { className: styles.classifyConditionContent },
            React.createElement(Form.List, { name: "condictions", initialValue: conditionRules }, (fields, { add, remove }) => (React.createElement(React.Fragment, null, fields.map((field, index) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return (React.createElement(Space, { key: field.key, align: "baseline" },
                    React.createElement("div", { className: classnames(styles.classifyConditionItem, form.getFieldValue('condictions').length <= 1 ? styles.classifyConditionItemRadius : {}) },
                        React.createElement("span", { className: styles.classifyConditionItemConnect }, connectText),
                        React.createElement(Form.Item, Object.assign({ className: styles.classifyConditionItemOption }, field, { name: [field.name, 'field'] }),
                            React.createElement(Select, { getPopupContainer: node => node.parentElement, style: { width: index === 0 ? 144 : 128 }, suffixIcon: React.createElement(TriangleDownIcon, null), onChange: (value) => handleSelectChange(value, index) },
                                React.createElement(Option, { value: "from" }, getIn18Text('FAJIANREN')),
                                React.createElement(Option, { value: "to" }, getIn18Text('SHOUJIANREN')),
                                React.createElement(Option, { value: "cc" }, getIn18Text('CHAOSONGREN')),
                                React.createElement(Option, { value: "recipients" }, getIn18Text('SHOUJIANRENHUOCHAO')),
                                React.createElement(Option, { value: "subject" }, getIn18Text('ZHUTI')),
                                React.createElement(Option, { value: "body" }, getIn18Text('YOUJIANZHENGWEN')),
                                React.createElement(Option, { value: "attachmentName" }, getIn18Text('FUJIANMINGCHENG')))),
                        React.createElement(Form.Item, Object.assign({}, field, { name: [field.name, 'operator'] }),
                            React.createElement(Select, { getPopupContainer: node => node.parentElement, style: { width: 84 }, suffixIcon: React.createElement(TriangleDownIcon, null) }, ((_a = form.getFieldValue('condictions')[index]) === null || _a === void 0 ? void 0 : _a.field) === MAIL_CLASSIFY_BODY_FIELD ? (React.createElement(React.Fragment, null,
                                React.createElement(Option, { value: "match" }, getIn18Text('BAOHAN')),
                                React.createElement(Option, { value: "unmatch" }, getIn18Text('BUBAOHAN')))) : (React.createElement(React.Fragment, null,
                                React.createElement(Option, { value: "contains" }, getIn18Text('BAOHAN')),
                                React.createElement(Option, { value: "excludes" }, getIn18Text('BUBAOHAN')))))),
                        React.createElement("div", { className: classnames(styles.classifyConditionItemInput, isNonMailOption(index) ? '' : styles.classifyConditionItemInputMail) }, isNonMailOption(index) ? (React.createElement(Form.Item, Object.assign({}, field, { name: [field.name, 'operand'], rules: [{ required: true, message: getIn18Text('QINGSHURUNEIRONG') }, { validator: validatorRule(index) }, { validator: validatorTextLength }], getValueFromEvent: valList => filterValueForm(valList, 'other') }),
                            React.createElement(Select, Object.assign({}, (subjectEditState && ((_b = rules[index]) === null || _b === void 0 ? void 0 : _b.field) === 'subject' && !(((_e = (_d = (_c = form.getFieldValue('condictions')) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.operand) === null || _e === void 0 ? void 0 : _e.length) > 0)
                                ? { searchValue }
                                : {}), { onSearch: (str) => handleNonMailSearch(str, index), allowClear: true, suffixIcon: React.createElement(TriangleDownIcon, null), removeIcon: React.createElement(TagCloseIcon, null), placeholder: `可输入多个${getNonMailFieldText((_f = form.getFieldValue('condictions')[index]) === null || _f === void 0 ? void 0 : _f.field)}，按回车确认`, mode: "tags", maxTagTextLength: 200, style: { width: '100%' }, open: false, autoFocus: index === currentIndex || (subjectEditState && ((_g = rules[index]) === null || _g === void 0 ? void 0 : _g.field) === 'subject'), className: styles.classifyTagSelect, onChange: () => {
                                    if (index === currentIndex) {
                                        handleSearch('');
                                    }
                                }, onSelect: handleSelect })))) : (React.createElement(Form.Item, Object.assign({}, field, { name: [field.name, 'operand'], rules: [{ required: true, message: getIn18Text('QINGSHURUNEIRONG') }, { validator: validatorRule(index) }], getValueFromEvent: valList => filterValueForm(valList, 'mail'), className: styles.classifyConditionItemMail }),
                            React.createElement(ContactScheduleModal, { includeSelf: true, hideAvatar: true, unSelect: true, multiRow: true, allowClear: true, repeatToast: true, ceiling: 30, autoFocus: index === currentIndex, defaultSelectList: convert2ContactItem((_h = conditionRules[index]) === null || _h === void 0 ? void 0 : _h.operand), placeholder: getIn18Text('KESHURUYOUXIANG'), field: condFields[index], recent100: recent100, source: "mailClassify", style: { minHeight: 32 }, onMouseLeave: () => setCurrentIndex(-1), characterLimit: 50, useMultiAccount: true })))),
                        React.createElement("div", { className: styles.classifyConditionDelete, onClick: () => handleDelete(fields, remove, index) },
                            React.createElement(MinusCircleFilled, { style: { color: fields.length <= 1 ? 'rgba(163, 164, 169, .5)' : `${variables.text2}` } })),
                        React.createElement("div", { className: styles.classifyConditionAdd, onClick: () => handleAdd(fields, add, index) },
                            React.createElement(PlusCircleFilled, { style: { color: fields.length >= 10 ? 'rgba(56, 110, 231, .5)' : `${variables.text2}` } })))));
            })))))));
};
